import React, { Component } from "react";
import { createPortal } from "react-dom";
import Pencil from "editor/components/Icons/Pencil";
import styled from "styled-components";

const Portal = ({ children }) => createPortal(children, document.body);

const PopoverWrapper = styled.div`
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 11px rgba(0, 0, 0, 0.1);
  padding: 8px;
  position: absolute;
  transform: translateY(5px);
  z-index: 1000;
`;

const Backdrop = styled.div`
  background: transparent;
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
`;

const CustomButton = styled.button`
  padding: 6px;
  background: white;
  border-radius: 2px;
  outline: 1px solid #ebebeb;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: #E5F3FD;

    svg {
      fill: #44adf8;
    }
  }

  &:focus {
    outline: 1px solid #ebebeb;
  }
`;

class PropsPopover extends Component {
  constructor(props) {
    super(props);
    this.backdropRef = null;
    this.handlerRef = null;
    this.state = {
      visible: false,
      placement: {},
    };
  }

  componentDidUpdate() {
    const { visible } = this.state;
    if (visible && this.backdropRef && this.backdropRef.current) {
      this.backdropRef.current.addEventListener("click", this.deactivate);
    } else if (!visible && this.backdropRef && this.backdropRef.current) {
      this.backdropRef.current.removeEventListener("click", this.deactivate);
    }
  }

  componentWillUnmount() {
    if (this.backdropRef && this.backdropRef.current) {
      this.backdropRef.current.removeEventListener("click", this.deactivate);
    }
  }

  placeInPosition = () => {
    const { right, left, width, height, bottom } =
      this.handlerRef.current.getBoundingClientRect();

    const toTop = bottom / window.innerHeight > 0.9;

    const placement = {
      toTop,
      top: window.scrollY - (toTop ? height : 0) + bottom,
      transform: toTop ? "translateY(calc(-100% - 8px))" : "",
      left,
    };

    this.setState({ placement });
  };

  activate = () => {
    this.placeInPosition();
    this.setState({ visible: true });
  };

  deactivate = () => {
    this.setState({ visible: false });
  };

  setHandlerRef = (ref) => {
    this.handlerRef = { current: ref };
  };

  setBackdropRef = (ref) => {
    this.backdropRef = { current: ref };
  };

  render() {
    const { children } = this.props;
    const { visible, placement } = this.state;

    return (
      <div>
        <CustomButton
          type="button"
          ref={this.setHandlerRef}
          onClick={this.activate}
        >
          <Pencil size="12" color="#8F8F8F" />
        </CustomButton>
        {visible && (
          <Portal>
            <Backdrop ref={this.setBackdropRef} />
            <PopoverWrapper style={placement}>{children}</PopoverWrapper>
          </Portal>
        )}
      </div>
    );
  }
}

export default PropsPopover;
